import Vue                    from "vue";
import Router                 from "vue-router";
import Home                   from "./views/Home.vue";
import Tester                   from "./views/testers/Tester.vue";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    /* /// REDIRECTS FROM OLD SITE <<*/
    {
      path: "/:locale([A-Za-z][A-Za-z]-[A-Za-z][A-Za-z])?",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "",component: Home
        },
        {
          path: "/tester",component: Tester
          // meta: { heroMenu: true }
        },
        {
          path: "/:lang",component: Home
          // meta: { heroMenu: true }
        },

      ]
    }
  ]
});


export default router;
